import classNames from 'classnames'

import {
  EVENT_KEY_ARROW_LEFT,
  EVENT_KEY_ARROW_RIGHT,
} from '../../../constants/event'
import { useKeyboardListener } from '../../../hooks'
import {
  getHorizontalIconChevronDirection,
  IconChevron,
  IconNG,
} from '../../Icon'
import { BUTTON_NEXT } from '../FilesPreviewGallery.constants'
import { isButtonBack, isButtonNext } from '../FilesPreviewGallery.utils'

import * as styles from './ArrowButton.module.css'

function ArrowButton({
  className = styles.ArrowButton,
  type = BUTTON_NEXT,
  onClick,
}) {
  const isLeftSide = isButtonBack(type)

  const wrapperClassName = classNames(
    className,
    { [styles.rightBtn]: isButtonNext(type) },
    { [styles.leftBtn]: isLeftSide }
  )

  useKeyboardListener({
    callback: onClick,
    eventKey: isButtonNext(type) ? EVENT_KEY_ARROW_RIGHT : EVENT_KEY_ARROW_LEFT,
  })

  return (
    <div className={wrapperClassName}>
      <IconNG
        Icon={IconChevron}
        className={styles.btnWrapper}
        iconProps={{
          direction: getHorizontalIconChevronDirection(isLeftSide),
        }}
        onClick={onClick}
      />
    </div>
  )
}

export default ArrowButton
